import Link from "next/link";

// PropertyActions wordmark — the original shield-check glyph in a dark tile,
// "Property" in ink + "Actions" in action-green.
export function Logo({ footer = false }: { footer?: boolean }) {
  return (
    <Link href="/" className="inline-flex items-center gap-2.5 font-black" aria-label="PropertyActions home">
      <span className="grid h-[34px] w-[34px] place-items-center rounded-[9px] bg-ink text-white shadow-[0_10px_20px_rgba(16,24,32,.18)]">
        <svg width="21" height="21" viewBox="0 0 24 24" fill="none" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M5 10 12 4.2l7 5.8v8.4a1.3 1.3 0 0 1-1.3 1.3H6.3A1.3 1.3 0 0 1 5 18.4z" stroke="currentColor" strokeWidth="2.1" />
          <path d="m8.8 13.4 2.3 2.3 4.2-5" stroke="#168a5b" strokeWidth="2.4" />
        </svg>
      </span>
      <span className={`text-[18px] ${footer ? "text-ink" : ""}`}>
        Property<b className="text-action-dark">Actions</b>
      </span>
    </Link>
  );
}
